import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export function flowChartReducer(state = initialstate.flowChart, action) {
	switch (action.type) {
		case types.GET_FLOWCHART:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		case types.GET_FLOWCHART_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		case types.CLEAR_FLOWCHART: {
			return initialstate.flowChart;
		}
		case types.SAVE_FLOWCHART_CONNECTION:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {...state, edges: action.response};
			}
			return state;
		case types.DELETE_FLOWCHART_CONNECTION:
			return state;
		case types.CREATE_FLOWCHART_NEW_STEP:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return state;
			}
			return state;
		case types.SET_FLOWCHART_DOCUMENT_UPLOAD: {
			const newObject = {
				flowChartStepId: action.flowChartStepId
			};
			return {...state, flowChartDocumentUploadOn: newObject};
		}
		default:
			return state;
	}
}

export function flowChartsReducer(state = initialstate.flowCharts, action) {
	switch (action.type) {
		case types.GET_FLOWCHARTS:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				if (state?.data && action?.response?.data?.length > 0) {
					let flowChartState = state;
					const updatedData = state.data.filter(item => item.formBodyId !== action.response.data[0].formBodyId);
					updatedData.push(action.response.data[0]);
					flowChartState = {
						...flowChartState,
						data: updatedData
					};

					return flowChartState;
				}
				return action.response;
			}
			return state;
		default:
			return state;
	}
}